import { Injectable } from '@angular/core';
import { Batch } from '../interfaces/batch';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BatchCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/batches/' ;
  }

  // Create Batch
  add(record: Batch) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Batch Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Batchs List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Batch Object
  update(record: Batch) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Batch>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Batch Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
